export enum Position {
    STANDALONE = 'STANDALONE'
}
